import React, { FC } from 'react'
import { IconType } from '../../common/types'

const NucCart: FC<IconType> = ({ iconColor = 'currentColor', ...svgProps }) => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 21 19'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...svgProps}
    >
      <path
        d='M3.75 0.25C4.13672 0.25 4.48828 0.566406 4.55859 0.953125L4.62891 1.375H19.3945C20.1328 1.375 20.6953 2.11328 20.4844 2.81641L18.5859 9.56641C18.4453 10.0586 18.0234 10.375 17.4961 10.375H6.35156L6.66797 12.0625H17.5312C17.9883 12.0625 18.375 12.4492 18.375 12.9062C18.375 13.3984 17.9883 13.75 17.5312 13.75H5.96484C5.57812 13.75 5.22656 13.4688 5.15625 13.082L3.04688 1.9375H1.21875C0.726562 1.9375 0.375 1.58594 0.375 1.09375C0.375 0.636719 0.726562 0.25 1.21875 0.25H3.75ZM4.875 16.5625C4.875 15.6484 5.61328 14.875 6.5625 14.875C7.47656 14.875 8.25 15.6484 8.25 16.5625C8.25 17.5117 7.47656 18.25 6.5625 18.25C5.61328 18.25 4.875 17.5117 4.875 16.5625ZM18.375 16.5625C18.375 17.5117 17.6016 18.25 16.6875 18.25C15.7383 18.25 15 17.5117 15 16.5625C15 15.6484 15.7383 14.875 16.6875 14.875C17.6016 14.875 18.375 15.6484 18.375 16.5625Z'
        fill={iconColor}
      />
    </svg>
  )
}

export default NucCart
